// ESC/POS command to open cash drawer
const OPEN_DRAWER_COMMAND = new Uint8Array([0x1B, 0x70, 0x00, 0x19, 0xFA]);

export const openCashDrawer = async (): Promise<boolean> => {
  try {
    // Check if Web Serial API is available
    if (!('serial' in navigator)) {
      console.warn('Web Serial API not supported');
      return false;
    }

    // Request port access
    const port = await (navigator as any).serial.requestPort();
    await port.open({ baudRate: 9600 });

    // Get writer
    const writer = port.writable.getWriter();
    
    // Send open drawer command
    await writer.write(OPEN_DRAWER_COMMAND);
    
    // Release writer and close port
    writer.releaseLock();
    await port.close();
    
    return true;
  } catch (error) {
    console.error('Error opening cash drawer:', error);
    return false;
  }
};
